export default __webpack_public_path__ + "static/media/promotionArrow.af2ef07a.svg";